/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    WriteOnlyVerifyJSONWebTokenSerializer,
    WriteOnlyVerifyJSONWebTokenSerializerFromJSON,
    WriteOnlyVerifyJSONWebTokenSerializerToJSON,
} from '../models';

export interface ApiTokenVerifyCreateRequest {
    data: WriteOnlyVerifyJSONWebTokenSerializer;
}

/**
 * no description
 */
export class ApiTokenVerifyApi extends runtime.BaseAPI {

    /**
     * API View that checks the veracity of a token, returning the token if it is valid.
     */
    async apiTokenVerifyCreateRaw(requestParameters: ApiTokenVerifyCreateRequest): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling apiTokenVerifyCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api-token-verify/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WriteOnlyVerifyJSONWebTokenSerializerToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * API View that checks the veracity of a token, returning the token if it is valid.
     */
    async apiTokenVerifyCreate(requestParameters: ApiTokenVerifyCreateRequest): Promise<object> {
        const response = await this.apiTokenVerifyCreateRaw(requestParameters);
        return await response.value();
    }

}
